/*! @preserve
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014-2015 Giulio Canti
 *
 */
var t = require('./lib');
var templates = require('./lib/templates/bootstrap');
var i18n = require('./lib/i18n/en');

t.form.Form.templates = templates;
t.form.Form.i18n = i18n;

module.exports = t;



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/index.js
 ** module id = 81
 ** module chunks = 0
 **/